export var FinanceWidgetEvents;
(function (FinanceWidgetEvents) {
    FinanceWidgetEvents["DESTROY"] = "destroy";
    FinanceWidgetEvents["INITIALIZED"] = "initialized";
    FinanceWidgetEvents["FC_ACTIVE"] = "fc:active";
    FinanceWidgetEvents["FC_DATA"] = "fc:data";
    FinanceWidgetEvents["UPDATE_CAR"] = "fc:update_car";
    FinanceWidgetEvents["UPDATE_PRICE"] = "fc:update_car_price";
    FinanceWidgetEvents["FC_ACTIVE_CARD"] = "fc:active:card";
})(FinanceWidgetEvents || (FinanceWidgetEvents = {}));
//# sourceMappingURL=FinanceWidgetEvents.js.map